module.exports = __webpack_public_path__ + "101be85e5dce73a2ec9e40567546396d.svg";